import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { NavigationService } from '../../services/navigation.service';
import { ProjetoCadastroService } from '../../services/projeto-cadastro.service';
import { ProjetoAgregadorService } from '../../services/projeto-agregador.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-pg-indicadores-edit',
  templateUrl: './detalhe-pg-indicadores-edit.component.html',
  styleUrls: ['./detalhe-pg-indicadores-edit.component.scss']
})
export class DetalhePgIndicadoresEditComponent implements OnInit {
  indicador: IndicadoresProjeto;
  actionLabel: string = 'Novo';
  type: string = '';
  projeto: any;
  idProjeto: number;

  constructor(
    public activatedRoute: ActivatedRoute,
    private projetoService: ProjetoAgregadorService,
  ) {

  }

  ngOnInit(): void {
    this.indicador = this.activatedRoute.snapshot.data['entity'];
    this.type = this.activatedRoute.snapshot.data['type'];
    if (this.indicador?.id) {
      this.idProjeto = this.indicador.pg_id;
    } else {
      this.idProjeto = this.activatedRoute.snapshot.params.idProjeto;
      if (!this.idProjeto) {
        this.idProjeto = this.activatedRoute.snapshot.parent.parent.params.idProjeto; // programa
      }
    }
console.log( this.idProjeto );
    if( this.idProjeto ){
      this.projetoService.getById( this.idProjeto ).subscribe( ( res )=>{
        this.projeto = res;
      });      
    }

    if (this.indicador?.id) {
      this.actionLabel = 'Editar';
    }
  }
}

